// extracted by css-extract-rspack-plugin
export default {"spin":"spin-_PpxIL"};